import useRouter from "hooks/useRouter";
import { useEffect, useMemo } from "react";
import _ from "lodash";
import InvestorReconciliationDetailView from "../../components/InvestorReconciliationDetailView";
import SaleReconciliationDetailView from "features/ReconciliationReport/SaleReconciliationReport/components/SaleReconciliationDetailView";
import Utils from "general/utils/Utils";

InvestorReconciliationDetailScreen.propTypes = {};

function InvestorReconciliationDetailScreen(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();
    const hash = router?.location?.hash;
    const { parent, child } = useMemo(() => Utils.parseHash(hash), [hash]);

    const isInvestorTab = parent === 'investor-reconciliation';
    const isSaleTab = parent === 'sale-reconciliation';

    return (
        <div>
            {isInvestorTab ? (
                <InvestorReconciliationDetailView activeChildTab={child} />
            ) : isSaleTab ? (
                <SaleReconciliationDetailView primaryRole="INVESTOR" activeChildTab={child} />
            ) : (
                <></>
            )}
        </div>
    );
}

export default InvestorReconciliationDetailScreen;
